// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"639":"custom-event-polyfill","769":"object-is-polyfill"}[chunkId] + "." + {"639":"8c220d83","769":"5f00cf55"}[chunkId] + ".chunk.js";
};